<template>
  <div
    id="home-modal"
    class="fixed inset-0 z-20 overflow-y-auto duration-200 opacity-0"
  >
    <div
      class="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
    >
      <div class="fixed inset-0 transition-opacity">
        <div
          class="absolute inset-0 bg-black opacity-75"
          @click="closeModal"
        ></div>
      </div>

      <span class="sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;

      <div
        class="relative inline-block text-left align-bottom transition-all transform bg-black rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-xl lg:max-w-2xl xl:max-w-4xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-headline"
      >
        <button
          @click="closeModal"
          class="absolute top-0 right-0 z-20 -mt-6 -mr-6 focus:outline-none"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="30"
            height="30"
            class="text-white fill-current"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z"
            />
          </svg>
        </button>
        <div class="relative z-10">
          <div
            class="w-full h-full bg-center bg-no-repeat bg-cover"
            style="background-image: url('/images/banner-modal.jpg')"
          >
            <a href="https://wa.me/60102721682">
              <img src="/images/pop-banner.jpg" alt="" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: true,
    };
  },
  methods: {
    closeModal() {
      document.querySelector("#home-modal").classList.remove("active");
    },
  },
  // mounted () {
  // 	// this.isActive = true;
  // 	// window.onload = (event) => {
  // 	// 	this.isActive = true;
  // 	// };
  // }
};
</script>

<style>
#home-modal {
  pointer-events: none;
}
.active {
  opacity: 100 !important;
  pointer-events: auto !important;
}

.poppup-imag {
  width: auto;
  max-height: 90vh;
}
</style>
